import React from 'react';
import Dashboard from './Dashboard';

const RegulatoryDashboard = () => {
  return <Dashboard />;
};

export default RegulatoryDashboard;